import { useState } from "react";
import { ImagePlus, Loader2, Download } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { http, formatError } from "@/lib/api";

const promptFor = (lead) => {
  if (!lead) return "";
  const product = (lead.notes || "").match(/product:\s*([^·]+)/i)?.[1]?.trim();
  return `${product || "Self-heating meal bowl"} packaging branded for ${lead.company || lead.name}, shown as a retail box and the product beside it`;
};

export const MockupButton = ({ lead, testId, label = "Mockup" }) => {
  const [open, setOpen] = useState(false);
  const [prompt, setPrompt] = useState("");
  const [img, setImg] = useState(null);
  const [busy, setBusy] = useState(false);
  const show = () => { setPrompt(promptFor(lead)); setImg(null); setOpen(true); };
  const generate = async () => {
    setBusy(true);
    try { const { data } = await http.post("/images/mockup", { prompt }); setImg(`data:${data.mime};base64,${data.image}`); }
    catch (e) { toast.error(formatError(e)); }
    setBusy(false);
  };
  return (
    <>
      <button className={lead ? "hud-btn hud-btn-ghost !py-1 !px-3" : "hud-btn"} onClick={show} data-testid={testId}><ImagePlus size={13} /> {label}</button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#1d0702] border-white/15 max-w-2xl" data-testid="mockup-dialog">
          <DialogHeader>
            <DialogTitle className="font-display tracking-wider">Product Mockup{lead ? ` · ${lead.company || lead.name}` : ""}</DialogTitle>
            <DialogDescription className="text-slate-400">Describe the packaging or product shot. JARVIS renders it in the Omvexis style.</DialogDescription>
          </DialogHeader>
          <textarea className="hud-input min-h-[90px]" value={prompt} onChange={(e) => setPrompt(e.target.value)} placeholder="e.g. Flameless heater pad pack for a military ration kit, desert-tan box" data-testid="mockup-prompt-input" />
          <div className="flex gap-2">
            <button className="hud-btn" onClick={generate} disabled={busy || prompt.trim().length < 3} data-testid="mockup-generate-button">{busy ? <Loader2 size={13} className="animate-spin" /> : <ImagePlus size={13} />} {busy ? "Rendering… (up to a minute)" : "Generate"}</button>
            {img && <a className="hud-btn hud-btn-ghost" href={img} download="omvexis-mockup.png" data-testid="mockup-download-button"><Download size={13} /> Download</a>}
          </div>
          {img && <img src={img} alt="Generated product mockup" className="w-full max-h-[50vh] object-contain rounded-2xl border border-white/10" data-testid="mockup-image" />}
        </DialogContent>
      </Dialog>
    </>
  );
};
